/** Matches i4 `details_avail_flag = 'Y'` — only then is a member detail page link shown. */
export function isMemberDetailsLinkable(
  detailsAvailFlag?: string | null,
): boolean {
  return detailsAvailFlag === 'Y';
}
